export default "__VITE_ASSET__Bu6NWZ8U__"